// extracted by mini-css-extract-plugin
export default {"activelyLeading":"ActivelyLeading_activelyLeading__8ELuH","text":"ActivelyLeading_text__azEJ2","content":"ActivelyLeading_content__KkltY","image":"ActivelyLeading_image__gVCYT"};